import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  // Set item
  setItem(key: string, value) {
    return window.localStorage.setItem(key, value);
  }

  // Get item
  getItem(key: string) {
    return window.localStorage.getItem(key);
  }

  // JSON "get"
  getObject(key: string) {
    const data = this.getItem(key);
    if (!!data === false) { return null; }
    return JSON.parse(data);
  }

  // JSON "set"
  setObject(key: string, value: any) {
    this.setItem(key, JSON.stringify(value));
  }

  deleteKey(key: string) {
    window.localStorage.removeItem(key);
  }

  clear() {
    window.localStorage.clear();
  }

}
